import { render, staticRenderFns } from "./ComplaintUploadFilesDialog.vue?vue&type=template&id=508b51e0"
import script from "./ComplaintUploadFilesDialog.vue?vue&type=script&lang=js"
export * from "./ComplaintUploadFilesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports